
import { h, Prop, Event, type EventEmitter, Component} from '@stencil/core';
import { makeLogger } from '../../../../../logger/logger';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

const { info, warn } = makeLogger({
  pathToCurrentFile: 'components/result-page/search-tab/subcomponents/search-reset-button.tsx',
  loggersList: ['info', 'warn']
});

@Component({
  tag: 'uiaas-search-reset-all-button',
  shadow: false
})

export class SearchReset {

    @Prop() readonly horizontalFilterPanel?: boolean;
    @Prop() readonly disabledButton: boolean = false;
    @Prop({ mutable: true}) labelProvider?: labelProviderInterface;
    @Event({ eventName: 'search:reset' }) searchReset: EventEmitter<any>;//eslint-disable-line @typescript-eslint/no-explicit-any

    componentWillLoad() {
        if (!this.labelProvider) {
          info('Assigning default labelProvider to reset button component');
          this.labelProvider = (name, fallback) => {
              warn(
                'LabelProvider not provided in SearchTab component',
                [name, fallback]
              );
              return fallback;
          };
        }
    }

    render(): HTMLElement {
        return(
          <div slot="end" class={this.horizontalFilterPanel ? 'horizontal-reset-all' : 'empty'}>
            <qds-button
              disabled={this.disabledButton}
              type="button"
              class={{'reset-button-link':true,
                      'reset-button-link-horizontal':this.horizontalFilterPanel}}
              onClick={() => {
                  this.searchReset.emit();
              }}
              text= {this.labelProvider(
                'facets.reset',
                'Reset All'
              )}
              iconName="arrow-circular-clockwise"
              importance="subdued"
              size="medium"
            />
          </div>
        );
    }
}
